<app-loading *ngIf="loading"></app-loading>

<div class="panel-header panel-header-sm">
    <div class="row link-header ml-5">
        <div><a class="a-home" routerLink="/home">Home/</a></div>
        <div><a class="text-info">Inutilización de Numeración (DNIT)</a></div>
    </div>
</div>

<div class="main-content">

    <div class="row justify-content-center">
        <div class="col-md-10">
            <div class="card">
                <div class="card-header">
                    <h4 class="card-title">Inutilización de Numeración</h4>
                    <h6 class="category">Informa a DNIT un rango de numeración que no fue utilizado</h6>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-3">
                            <label><b>Establecimiento</b></label>
                            <input type="text" class="form-control form-control-sm" [value]="establecimiento" readonly />
                        </div>
                        <div class="col-md-3">
                            <label><b>Punto de Expedición</b></label>
                            <input type="text" class="form-control form-control-sm" maxlength="3"
                                [value]="punto" (input)="punto = $any($event.target).value" placeholder="001" readonly />
                        </div>
                        <div class="col-md-3">
                            <label><b>Tipo de Documento</b></label>
                            <select class="form-control form-control-sm" [value]="tipoDocumento"
                                (change)="tipoDocumento = $any($event.target).value">
                                <option value="FACT">FACT - Factura electrónica</option>
                                <option value="NC">NC - Nota de crédito electrónica</option>
                                <option value="NRE">NRE - Nota de remisión electrónica</option>
                            </select>
                        </div>
                        <div class="col-md-3">
                            <label><b>Serie (opcional)</b></label>
                            <input type="text" class="form-control form-control-sm" maxlength="2"
                                [value]="serie" (input)="serie = $any($event.target).value" placeholder="AB" />
                        </div>
                    </div>

                    <div class="row mt-3">
                        <div class="col-md-6">
                            <label><b>Número inicial (desde)</b></label>
                            <input type="number" class="form-control form-control-sm" min="1"
                                [value]="desde" (input)="desde = $any($event.target).value" placeholder="1" />
                        </div>
                        <div class="col-md-6">
                            <label><b>Número final (hasta)</b></label>
                            <input type="number" class="form-control form-control-sm" min="1"
                                [value]="hasta" (input)="hasta = $any($event.target).value" placeholder="10" />
                        </div>
                    </div>

                    <div class="row mt-3">
                        <div class="col-md-12">
                            <label><b>Motivo</b></label>
                            <textarea class="form-control form-control-sm" rows="3" maxlength="500"
                                [value]="motivo" (input)="motivo = $any($event.target).value"
                                placeholder="Motivo de la inutilización (5 a 500 caracteres)"></textarea>
                        </div>
                    </div>

                    <!-- Acciones -->
                    <div class="row mt-3">
                        <div class="col-md-6">
                            <button class="btn btn-success btn-round w-100 font-weight-bold"
                                (click)="sendInutilizacion()" [disabled]="loading">
                                <i class="now-ui-icons arrows-1_share-66 mr-1"></i>
                                Enviar a DNIT
                            </button>
                        </div>
                        <div class="col-md-6">
                            <button class="btn btn-default btn-round w-100"
                                (click)="clearForm()" [disabled]="loading">
                                Limpiar
                            </button>
                        </div>
                    </div>

                    <!-- Resultado -->
                    <div class="row mt-3" *ngIf="resultMessage">
                        <div class="col-md-12">
                            <div class="alert alert-info">
                                {{ resultMessage }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
